<article [ngClass]="{'disabled-div': !isLoading && Props?.isExpired, 'home-tile': appearance === 'home'}"
    role="button" [attr.tabindex]="isLoading || Props?.isExpired ? -1 : 0"
    [attr.aria-disabled]="isLoading || Props?.isExpired" [attr.aria-label]="Props?.name || 'Cargando producto'"
    (keydown.enter)="onSelect(Props)" (keydown.space)="$event.preventDefault(); onSelect(Props)"
    (click)="onSelect(Props)">
    <figure>
        <ng-container *ngIf="!isLoading else img_loading">
            <img [src]="Props?.imgUrl" alt="" loading="lazy">
        </ng-container>
        <ng-template #img_loading>
            <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                    'width': appearance === 'home' ? '48px' : '32.76px',
                'border-radius': '6px',
                    'height': appearance === 'home' ? '48px' : '32.4px',
                'background-color': 'rgba(184, 184, 184, 0.2)'
                }">
            </ngx-skeleton-loader>
        </ng-template>
    </figure>
    <div class="description">
        <ng-container *ngIf="!isLoading else paraph_loading">
            <h3 [title]="Props?.name || ''">{{Props?.name}}</h3>
            <p *ngIf="!Props?.isNew; else newTag">{{description}}</p>
            <ng-template #newTag>
                <p class="new-tag">
                    {{(description.length >= 41
                    ? (description | slice:0:41) + '...' :
                    description) }} <span>Nuevo</span>
                </p>
            </ng-template>
        </ng-container>
        <ng-template #paraph_loading>
            <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                    'width': appearance === 'home' ? '80px' : '180px',
                'border-radius': '6px',
                'height': '6px',
                'background-color': 'rgba(184, 184, 184, 0.2)'
                }">
            </ngx-skeleton-loader>
            <ngx-skeleton-loader [ariaLabel]="'Cargando...'" [theme]="{
                    'width': appearance === 'home' ? '70px' : '130px',
                'border-radius': '6px',
                'height': '6px',
                'background-color': 'rgba(184, 184, 184, 0.2)'
                }">
            </ngx-skeleton-loader>
        </ng-template>
    </div>
</article>
